// Shared Gmail OAuth scope constant. Mirrors microsoftOAuth.ts's rationale for a single source of
// truth: both call sites (personal AddGmailAccount.tsx, organization OrganizationEmail/index.tsx)
// previously inlined their own, slightly different scope strings, which let scopes outside the
// Google Cloud Console OAuth consent screen's configured/authorized set (e.g. contacts.readonly,
// gmail.addons.current.message.readonly, gmail.send) drift into the requested params. Google
// rejects (or silently drops, depending on consent-screen publishing status) any requested scope
// that isn't also present in the Console's configured scope list, so the two sets must stay
// byte-for-byte aligned. GMAIL_SCOPES below is exactly — no more, no less — the set configured on
// the OAuth consent screen; every Gmail OAuth flow in this app must build its `scope` param only
// from this constant.
export const GMAIL_SCOPES = [
  "openid",
  "https://www.googleapis.com/auth/userinfo.email",
  "https://www.googleapis.com/auth/userinfo.profile",
  "https://mail.google.com/",
  "https://www.googleapis.com/auth/gmail.modify",
  "https://www.googleapis.com/auth/gmail.compose",
  "https://www.googleapis.com/auth/gmail.readonly",
  "https://www.googleapis.com/auth/gmail.metadata",
  "https://www.googleapis.com/auth/gmail.labels",
  "https://www.googleapis.com/auth/gmail.addons.current.action.compose",
  "https://www.googleapis.com/auth/gmail.addons.current.message.action",
].join(" ");
